export default __webpack_public_path__ + "static/media/Covert_Affair.f2d76f07.mp3";